import React from 'react'
import claimImg from '../../../assets/cleam-img.png'
import SectionWrapper from '../../Components/SectionWrapper'
import { Grid, Link } from '@mui/material'
import { useTheme } from '@emotion/react'
import { SectionHeading } from '../../Styles/style'
import ethscan from '../../../assets/eth-scan.png'

const Claim = () => {
    const theme = useTheme()
  return (
    <div style={{backgroundImage: `url(${claimImg})`}}>
        <SectionWrapper>
            <Grid xs={12} sx={{textAlign:'center'}}>
                {/* <Typography variant="subtitle1" color={theme.textPrimary}>4% Tokens are reserved to airdrop $PEPE holders</Typography> */}
                <Link  href="https://app.uniswap.org/#/swap?outputCurrency=0x24ABCa46E6bF3e18b870F9F5Cc1A361ECE13C68d" sx={{textDecoration:"none", cursor:"pointer"}}><SectionHeading color={theme.textPrimary} p="20px 0">Buy Now!</SectionHeading></Link>
                <img src={ethscan} alt="Eth-scan"/>
            </Grid>
        </SectionWrapper>
    </div>
  )
}

export default Claim